"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Noco;
    }
});
require("~/instrument");
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _core = require("@nestjs/core");
const _clear = /*#__PURE__*/ _interop_require_default(require("clear"));
const _express = /*#__PURE__*/ _interop_require_wildcard(require("express"));
const _uuid = require("uuid");
const _dotenv = /*#__PURE__*/ _interop_require_default(require("dotenv"));
const _requestip = /*#__PURE__*/ _interop_require_default(require("request-ip"));
const _cookieparser = /*#__PURE__*/ _interop_require_default(require("cookie-parser"));
const _debug = require("nc-gui/utils/debug");
const _globals = require("~/utils/globals");
const _appmodule = require("~/app.module");
const _utils = require("~/utils");
const _appUrl = require("~/utils/appUrl");
const _models = require("~/models");
const _redisHelpers = require("~/helpers/redisHelpers");
const _RedisIoAdapter = require("~/gateways/RedisIoAdapter");
const _AppSettings = require("~/interface/AppSettings");
const _constants = require("~/constants");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
_dotenv.default.config();
if ([
    'development',
    'test'
].includes(process.env.NODE_ENV)) {
    require('source-map-support').install();
}
let Noco = class Noco {
    static get dashboardUrl() {
        return (0, _appUrl.getAppUrl)();
    }
    getConfig() {
        return this.config;
    }
    getToolDir() {
        var _this_getConfig;
        return (_this_getConfig = this.getConfig()) == null ? void 0 : _this_getConfig.toolDir;
    }
    addToContext(context) {
        this.requestContext = context;
    }
    static get ncMeta() {
        return this._ncMeta;
    }
    static get nestApp() {
        return this._nestApp;
    }
    static get ncAudit() {
        var _this__ncAudit;
        return (_this__ncAudit = this._ncAudit) != null ? _this__ncAudit : this._ncMeta;
    }
    get ncMeta() {
        return Noco._ncMeta;
    }
    get ncAudit() {
        return Noco._ncAudit;
    }
    static getConfig() {
        return this.config;
    }
    static isEE() {
        return this.ee || process.env.NC_CLOUD === 'true';
    }
    static async loadEEState() {
        try {
            return this.ee = _utils.isEE;
        } catch (unused) {}
        return this.ee = false;
    }
    static async init(param, httpServer, server) {
        var _process_env_NC_DASHBOARD_URL;
        const nestApp = await _core.NestFactory.create(_appmodule.AppModule, {
            bufferLogs: true,
            bodyParser: false
        });
        Noco._nestApp = nestApp;
        this.initCustomLogger(nestApp);
        _debug.NcDebug.log('Custom logger initialized');
        nestApp.flushLogs();
        if (module == null ? void 0 : module.hot) {
            var _module_hot_accept, _module_hot, _module_hot_dispose, _module_hot1;
            (_module_hot = module.hot) == null ? void 0 : (_module_hot_accept = _module_hot.accept) == null ? void 0 : _module_hot_accept.call(_module_hot);
            (_module_hot1 = module.hot) == null ? void 0 : (_module_hot_dispose = _module_hot1.dispose) == null ? void 0 : _module_hot_dispose.call(_module_hot1, ()=>nestApp.close());
        }
        try {
            this.sharp = (await Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("sharp")))).default;
            this.sharp.concurrency(1);
            this.sharp.cache(false);
        } catch (unused) {
            console.error('Sharp is not available for your platform, thumbnail generation will be skipped');
        }
        try {
        // TODO: enable later cc @DarkPhoenix2704
        // this.canvas = await import('@napi-rs/canvas');
        // await definePDFJSModule(() => import('pdfjs-dist/legacy/build/pdf.mjs'));
        // this.isPdfjsInitialized = true;
        } catch (e) {
            console.error(e);
            console.error('Canvas is not available for your platform, thumbnail generation will be skipped');
        }
        if (process.env.NC_WORKER_CONTAINER === 'true') {
            if (!(0, _redisHelpers.getRedisURL)()) {
                throw new Error('NC_REDIS_URL is required');
            }
            process.env.NC_DISABLE_TELE = 'true';
        }
        this._httpServer = nestApp.getHttpAdapter().getInstance();
        this._server = server;
        nestApp.use(_requestip.default.mw());
        nestApp.use((0, _cookieparser.default)());
        const redisIoAdapter = new _RedisIoAdapter.RedisIoAdapter(httpServer);
        await redisIoAdapter.connectToRedis();
        nestApp.useWebSocketAdapter(redisIoAdapter);
        _debug.NcDebug.log('Websocket adapter initialized');
        await nestApp.init();
        _debug.NcDebug.log('Nest app initialized');
        await nestApp.enableShutdownHooks();
        _debug.NcDebug.log('Shutdown hooks enabled');
        const dashboardPath = (_process_env_NC_DASHBOARD_URL = process.env.NC_DASHBOARD_URL) != null ? _process_env_NC_DASHBOARD_URL : '/dashboard';
        server.use(_express.static(_path.default.join(__dirname, 'public')));
        if (dashboardPath !== '/' && dashboardPath !== '') {
            server.get('/', (_req, res)=>res.redirect(dashboardPath));
        }
        await _models.Integration.init();
        _debug.NcDebug.log('Integration initialized');
        if (process.env.NC_WORKER_CONTAINER !== 'true') {
            await _models.DataReflection.init();
        }
        return nestApp.getHttpAdapter().getInstance();
    }
    static get httpServer() {
        return this._httpServer;
    }
    static get server() {
        return this._server;
    }
    static async initJwt() {
        var _this_config_auth, _this_config, _this;
        if ((_this_config = this.config) == null ? void 0 : (_this_config_auth = _this_config.auth) == null ? void 0 : _this_config_auth.jwt) {
            var _this_config_auth_jwt_options;
            if (!this.config.auth.jwt.secret) {
                var _this1;
                let secret = (_this1 = await this._ncMeta.metaGet(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
                    key: 'nc_auth_jwt_secret'
                })) == null ? void 0 : _this1.value;
                if (!secret) {
                    await this._ncMeta.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
                        key: 'nc_auth_jwt_secret',
                        value: secret = (0, _uuid.v4)()
                    }, true);
                }
                this.config.auth.jwt.secret = secret;
            }
            this.config.auth.jwt.options = this.config.auth.jwt.options || {};
            if (!((_this_config_auth_jwt_options = this.config.auth.jwt.options) == null ? void 0 : _this_config_auth_jwt_options.expiresIn)) {
                var _process_env_NC_JWT_EXPIRES_IN;
                this.config.auth.jwt.options.expiresIn = (_process_env_NC_JWT_EXPIRES_IN = process.env.NC_JWT_EXPIRES_IN) != null ? _process_env_NC_JWT_EXPIRES_IN : '10h';
            }
        }
        let serverId = (_this = await this._ncMeta.metaGet(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
            key: 'nc_server_id'
        })) == null ? void 0 : _this.value;
        if (!serverId) {
            await this._ncMeta.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
                key: 'nc_server_id',
                value: serverId = _utils.T.id
            }, true);
        }
        process.env.NC_SERVER_UUID = serverId;
    }
    static initCustomLogger(_nestApp) {
    // setup custom logger for nestjs if needed
    }
    static async prepareAuditService() {}
    static async getAppSettings(refresh = false) {
        // Force refresh or first load
        if (refresh || !this._appSettings) {
            await this.loadAppSettings();
        }
        return _extends({}, this._appSettings);
    }
    static async loadAppSettings() {
        try {
            const storeData = await _models.Store.get(_constants.NC_APP_SETTINGS, false, this._ncMeta);
            if (storeData == null ? void 0 : storeData.value) {
                this._appSettings = _extends({}, _AppSettings.DEFAULT_APP_SETTINGS, JSON.parse(storeData.value));
            } else {
                this._appSettings = _extends({}, _AppSettings.DEFAULT_APP_SETTINGS);
            }
        } catch (error) {
            // Log error but don't fail - use defaults
            console.error('Failed to load app settings, using defaults:', error);
            this._appSettings = _extends({}, _AppSettings.DEFAULT_APP_SETTINGS);
        }
    }
    static async updateAppSettings(settings) {
        const currentSettings = await this.getAppSettings();
        const newSettings = _extends({}, currentSettings, settings);
        await _models.Store.saveOrUpdate({
            key: _constants.NC_APP_SETTINGS,
            value: JSON.stringify(newSettings)
        }, this._ncMeta);
        // Update cache
        this._appSettings = newSettings;
        return _extends({}, newSettings);
    }
    static resetAppSettingsCache() {
        this._appSettings = null;
    }
    constructor(){
        process.env.PORT = process.env.PORT || '8080';
        // todo: move
        // if env variable NC_MINIMAL_DBS is set, then disable base creation with external sources
        if (process.env.NC_MINIMAL_DBS === 'true') {
            process.env.NC_CONNECT_TO_EXTERNAL_DB_DISABLED = 'true';
        }
        this.router = _express.Router();
        this.baseRouter = _express.Router();
        (0, _clear.default)();
    /******************* prints : end *******************/ }
};
Noco.env = '_noco';
Noco._appSettings = null;
